import * as React from "react"
import { Container, Row, Col, Dropdown, Card } from "react-bootstrap"
import "./index.scss"
import * as topojson from "topojson-client"
import _data from "/static/US_States_Top3.json"
console.log(_data)
import useWindowsSize from "../hooks/useWindowSize"
import Rating from "../components/Rating/Rating"
import SvgMap from "../components/SvgMap/SvgMap"

const initialState = {
  properties: {
    FREQUENCY: 41,
    MEAN_Rating: 3.4707317073170736,
    MIN_Rating: 0,
    OBJECTID: 1,
    STATE_NAME: "Alabama",
    Shape_Area: 189968432426.9145,
    Shape_Length: 2506744.518907471,
    business1: "Iniquities",
    business2: "Enchantasys",
    business3: "Fantasyland",
    pop: 5024279,
    rating1: 4.900000095367432,
    rating2: 4.800000190734863,
    rating3: 4.699999809265137,
    reviews1: 34,
    reviews2: 17,
    reviews3: 23,
    shop_count: 41,
    shops_100k: 0.8160374851794656,
  },
}
const IndexPage = () => {
  const svgRef = React.useRef()
  const [state, setState] = React.useState(initialState)
  const [data, setData] = React.useState(null)
  const [dimension, setDimension] = React.useState([300, 150])
  const windowSize = useWindowsSize()

  const onStateChangeHandler = d => {
    setState(prev => {
      return d
    })
  }
  React.useEffect(() => {
    console.log(data)
    const features = topojson.feature(_data, "US_States_top3")
    setData(features)
  }, [])

  React.useEffect(() => {
    if (svgRef.current) {
      const { clientWidth, clientHeight } = svgRef.current
      setDimension([clientWidth, clientHeight])
    }
  }, [svgRef.current])

  return (
    <main className="App">
      <Container>
        <Row>
          <Col
            lg={8}
            md={12}
            className="order-lg-2"
            style={{ minHeight: "50vh" }}
          >
            <div
              style={{ position: "relative", height: "100%", width: "100%" }}
            >
              <h1 className="mapTitle">Adult Shop Density Map</h1>
              <SvgMap onSetState={setState} data={data} state={state}></SvgMap>
            </div>
          </Col>
          <Col lg={4} className="order-lg-1">
            <Card bg="secondary" className="text-center">
              <Card.Body>
                <div className="mb-4">
                  <Dropdown>
                    <Dropdown.Toggle
                      variant="primary"
                      style={{ width: "100%" }}
                    >
                      Please select a state
                    </Dropdown.Toggle>
                    {data && (
                      <Dropdown.Menu>
                        {data.features.map(d => (
                          <Dropdown.Item
                            key={d.properties.STATE_NAME}
                            onClick={() => onStateChangeHandler(d)}
                          >
                            {d.properties.STATE_NAME}
                          </Dropdown.Item>
                        ))}
                      </Dropdown.Menu>
                    )}
                  </Dropdown>
                  <Card className="my-3">
                    <Card.Title className="StateLabel">
                      {state.properties.STATE_NAME}
                    </Card.Title>
                  </Card>
                </div>

                <div className="my-4">
                  <Card.Title>
                    Number of adult shops per 100,000 people
                  </Card.Title>
                  <Card text="primary" className="Digit">
                    <span className="Digit__text">
                      {state.properties.shops_100k.toFixed(2)}
                    </span>
                  </Card>
                </div>
                <div className="my-4">
                  <Card.Title>
                    Average reviews of adult shops in the state
                  </Card.Title>
                  <Card text="primary" className="Digit">
                    <span className="Digit__text">
                      {state.properties["MEAN_Rating"].toFixed(2)}
                    </span>
                  </Card>
                </div>

                <Card.Title>Best reviewed Adult Shops in the State</Card.Title>
                <Card>
                  <Card.Body>
                    <Rating
                      business={state.properties.business1}
                      rating={state.properties.rating1}
                      reviews={state.properties.reviews1}
                    ></Rating>
                    <hr />
                    <Rating
                      business={state.properties.business2}
                      rating={state.properties.rating2}
                      reviews={state.properties.reviews2}
                    ></Rating>
                    <hr></hr>
                    <Rating
                      business={state.properties.business3}
                      rating={state.properties.rating3}
                      reviews={state.properties.reviews3}
                    ></Rating>
                  </Card.Body>
                </Card>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </main>
  )
}

export default IndexPage
